import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "render"];

  connect() {
    const raw = this._readRawJson();
    if (!raw) return;

    let formatted = raw;
    try {
      const obj = JSON.parse(raw);
      formatted = JSON.stringify(obj, null, 2);
    } catch (_) {
    }

    const html = this._syntaxHighlight(formatted);
    this.renderTarget.innerHTML = html;
  }

  copy() {
    const text = this.renderTarget.innerText || "";
    if (!text) return;

    navigator.clipboard?.writeText(text)
      .then(() => this._flash("Copied!"))
      .catch(() => this._flash("Failed to copy to clipboard"));
  }

  // === helpers ===
  _readRawJson() {
    if (this.hasSourceTarget) {
      return (this.sourceTarget.textContent || "").trim();
    }
    const ds = this.element.dataset.json;
    if (ds && typeof ds === "string") return ds.trim();

    return "";
  }

  _syntaxHighlight(str) {
    const esc = (s) =>
      s.replace(/&/g, "&amp;")
       .replace(/</g, "&lt;")
       .replace(/>/g, "&gt;");

    const escaped = esc(str);

    const withKeys = escaped.replace(
      /^( *)"([^"]+)":/gm,
      (_, indent, key) =>
        `${indent}<span class="text-black-700">"<span class="text-black-600">${key}</span>"</span>:`
    );

    const withValues = withKeys
      // string values
      .replace(/(:\s*)"(.*?)"(?=\s*[,\}\]])/g, (m, p1, val) => {
        return `${p1}<span class="text-black-600">"${val}"</span>`;
      })
      // numbers
      .replace(/(:\s*)(-?\d+(?:\.\d+)?)(?=\s*[,\}\]])/g, (m, p1, val) => {
        return `${p1}<span class="text-black-600">${val}</span>`;
      })
      // booleans
      .replace(/(:\s*)(true|false)(?=\s*[,\}\]])/g, (m, p1, val) => {
        return `${p1}<span class="text-black-600">${val}</span>`;
      })
      // null
      .replace(/(:\s*)(null)(?=\s*[,\}\]])/g, (m, p1, val) => {
        return `${p1}<span class="text-black-600">${val}</span>`;
      });


    return `<pre class="text-paragraph-s whitespace-pre overflow-x-auto bg-black-25 text-black-600 px-4">${withValues}</pre>`;
  }

  _flash(msg) {
    const el = document.createElement("div");
    el.textContent = msg;
    el.className = "fixed z-[5000] bottom-24 left-1/2 -translate-x-1/2 bg-black-900 text-white text-paragraph-s px-12 py-8 rounded-8 shadow";
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 1200);
  }
}
